import * as t from 'ts-codec';

export const IssueDeveloperTokenParams = t.object({
  app_id: t.string
});
export type IssueDeveloperTokenParams = t.Encoded<typeof IssueDeveloperTokenParams>;

export const TokenResponse = t.string;
export type TokenResponse = t.Encoded<typeof TokenResponse>;

export const IssueOrganizationTokenParams = t.object({
  org_id: t.string
});
export type IssueOrganizationTokenParams = t.Encoded<typeof IssueOrganizationTokenParams>;
